__turbopack_context__.v({
  "iframe": "j2LGWG_iframe",
});
